module.exports = __webpack_public_path__ + "img/bckarw.26f8ab93.svg";